import { Injectable } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import {
  ConfiguracionFirma,
  FirmanteNif,
  PosicionFormulario,
  TipoFirma
} from 'src/app/pages/configuracion/Envios/documentos/models/firmante-nif';
import {
  isCampoRowColocada,
  isCasillaRowColocada,
  isFirmaRowColocada,
  isPalabraRowColocada
} from 'src/app/pages/configuracion/Envios/documentos/services/formulario-documento-overlays';
import { Firmantes } from 'src/app/pages/configuracion/Envios/envios/models/firmantes';
import { TipoEnvio } from 'src/app/pages/configuracion/Envios/envios/models/tipo-envio';
import { ConfiguracionRlt } from 'src/app/pages/configuracion/configuracion-rlt/models/configuracion-rlt';
import { DocumentoEnvioSimple } from 'src/app/pages/configuracion/envio-simple/models/documento-envio-simple';
import {
  EnvioSimpleEstadoFlujoSalida,
  OpcionesMapProcesaEnvioSimpleSalida,
  ProcesaEnvioSimpleDocumentoRequest,
  ProcesaEnvioSimpleFirmanteRequest,
  ProcesaEnvioSimpleRequest,
  VERSION_CONTRATO_PROCESA_ENVIO_SIMPLE
} from 'src/app/pages/configuracion/envio-simple/models/envio-simple-procesa-envio-simple.model';
import { FirmanteEnvioSimple } from 'src/app/pages/configuracion/envio-simple/models/firmante-envio-simple';
import { EmpleadoCrud } from 'src/app/pages/empleados/models/empleado';

@Injectable({
  providedIn: 'root'
})
export class ConversionDatosApiService {

  constructor() { }

  mapEnviosEntrada(response: any[]){
    if(!response) return null;
    return response.map(({
                          Activo,
                          Body,
                          BodySMS,
                          // DiasRecordatorio,
                          // Directorio,
                          // DocumentosEnvioProgramado,
                          EnvioMasivo,
                          EnvioSMS,
                          OrdenTelefonoSms,
                          SecurizadoSms,
                          OrdenTelefonoOTP,
                          Expire_time,
                          Firmantes,
                          IdTipoEnvio,
                          IdV3TipoEnvio,
                          EnvioMail,
                          OrdenMail,
                          MailPrincipal,
                          Nombre,
                          // numeroAdjuntos,
                          // Programado,
                          Recordatorio,
                          // Recordatorios,
                          Reminders_String,
                          // SolicitarAdjunto,
                          // SubDirectorio,
                          Subject,
                          // TipoMail,
                          TiposDocumento,
                          EsSoloGenericos,
                          EsRLT,
                          NombreComienzaPorLibra,
                          EnvioParalelo,
                          CanalEnvioActivo
                          })=>({
                          activo:Activo,
                          body:Body,
                          bodySMS:BodySMS,
                          // diasRecordatorio: DiasRecordatorio,
                          // directorio: Directorio,
                          // documentosEnvioProgramado: DocumentosEnvioProgramado,
                          envioMasivo: EnvioMasivo,
                          envioSMS: EnvioSMS,
                          ordenTelefonoSMS: OrdenTelefonoSms,
                          securizadoSMS: SecurizadoSms,
                          ordenTelefonoOTP: OrdenTelefonoOTP,
                          caducidad: Expire_time,
                          firmantes: this.mapFirmantesEntrada(Firmantes),
                          // firmantes: Firmantes,
                          idTipoEnvio: IdTipoEnvio,
                          idV3TipoEnvio: IdV3TipoEnvio,
                          envioMail: EnvioMail,
                          ordenMail: OrdenMail,
                          mailPrincipal: MailPrincipal,
                          nombre: Nombre,
                          // numeroAdjuntos: numeroAdjuntos,
                          // programado: Programado,
                          recordatorio: Recordatorio,
                          // recordatorios: Recordatorios,
                          reminders_String: Reminders_String,
                          // solicitarAdjunto: SolicitarAdjunto,
                          // subDirectorio: SubDirectorio,
                          subject: Subject,
                          // tipoMail: TipoMail,
                          tiposDocumento: this.mapDocumentosEntrada(TiposDocumento),
                          // tiposDocumento: TiposDocumento,
                          esSoloGenericos: EsSoloGenericos,
                          esRLT: EsRLT,
                          nombreComienzaLibra: NombreComienzaPorLibra,
                          envioParalelo: EnvioParalelo,
                          canalEnvioActivo: CanalEnvioActivo
                          }))
  }

  mapEnviosSalida(data:any){
    if(!data) return null;
    const { idV3TipoEnvio: IdV3TipoEnvio,
            activo: Activo,
            body: Body,
            bodySMS: BodySMS,
            //defectoBody: DefectoBody,
            //defectoSubject: DefectoSubject,
            // documentosEnvioProgramado: DocumentosEnvioProgramado,
            // estado: Estado,
            envioMasivo: EnvioMasivo,
            envioSMS: EnvioSMS,
            ordenTelefonoSMS: OrdenTelefonoSms,
            securizadoSMS: SecurizadoSms,
            ordenTelefonoOTP: OrdenTelefonoOTP,
            caducidad: Expire_time,
            firmantes: Firmantes,
            envioMail: EnvioMail,
            ordenMail: OrdenMail,
            // mailPrincipal: MailPrincipal,
            nombre: Nombre,
            // numeroAdjuntos: NumeroAdjuntos,
            // programado:Programado,
            recordatorio: Recordatorio,
            reminders_String: Reminders_String,
            // solicitarAdjunto: SolicitarAdjunto,
            subject: Subject,
            tiposDocumento: TiposDocumento,
            esSoloGenericos: EsSoloGenericos,
            esRLT: EsRLT,
            nombreComienzaLibra: NombreComienzaPorLibra,
            envioParalelo: EnvioParalelo,
            canalEnvioActivo: CanalEnvioActivo
          } = data;


    const newObject = { IdV3TipoEnvio,
                        Activo,
                        Body,
                        BodySMS,
                        // DocumentosEnvioProgramado,
                        // Estado,
                        EnvioMasivo,
                        EnvioSMS,
                        OrdenTelefonoSms,
                        SecurizadoSms,
                        OrdenTelefonoOTP,
                        Expire_time,
                        Firmantes,
                        EnvioMail,
                        OrdenMail,
                        // MailPrincipal,
                        Nombre,
                        // NumeroAdjuntos,
                        // Programado,
                        Recordatorio,
                        Reminders_String,
                        // SolicitarAdjunto,
                        Subject,
                        TiposDocumento,
                        EsSoloGenericos,
                        EsRLT,
                        NombreComienzaPorLibra,
                        EnvioParalelo,
                        CanalEnvioActivo
                      }

          return newObject
  }

  mapFirmantesEntrada(firmantes: any[]){
    if(!firmantes) return null;
    return firmantes.map(({Orden, TipoBusqueda, TipoDestinatario, TipoFirmante})=>({orden: Orden, tipoBusqueda: TipoBusqueda, tipoDestinatario: TipoDestinatario, tipoFirmante: TipoFirmante}))
  }

  mapFirmantesSalida(datos: any[]){
    if(!datos) return null;
    return datos.map(({ orden, tipoBusqueda, tipoDestinatario, tipoFirmante}) => ({ Orden: orden, TipoBusqueda: tipoBusqueda, TipoDestinatario: tipoDestinatario, TipoFirmante: tipoFirmante}))
  }

  mapTiposEnvioDesplegablesEntrada(response:any[]){
    if(!response) return null;
    return response.map(({Codigo, Descripcion})=>({codigo: Codigo, desc: Descripcion}))
  }

  mapTiposEnvioDesplegablesEntradaSingle(data:any){
    if(!data) return null;
    const newObject = { codigo: data.Codigo, desc: data.Descripcion };
    return newObject;
  }

  mapTiposEnvioDesplegablesSalida(data:any){
    if(!data) return null;
    const newObject = { Codigo: data.codigo, Descripcion: data.desc };
    return newObject;
  }

  mapCoordenadasSimpleSalida(data:any[]){

    if(!data) return null;
    return data.map(
    ({
      // id,
      pagina,
      posicionHeight,
      posicionLeft,
      posicionRight,
      posicionTop,
      posicionWidth,
      identificador,
      nombreCampo,
      valorPorDefecto,
      obligatorio
    }) =>
    ({
      // Id: id,
      Pagina: pagina,
      PosicionHeight: ((posicionHeight ?? 0) * 100),
      PosicionLeft: ((posicionLeft ?? 0) * 100),
      PosicionRight: ((posicionRight ?? 0) * 100),
      PosicionTop: ((posicionTop ?? 0) * 100),
      PosicionWidth: ((posicionWidth ?? 0) * 100),
      NombreCampoTexto:nombreCampo,
      Nombre:identificador,
      TextoPorDefecto:valorPorDefecto,
      Obligatorio:obligatorio
    }))
  }

  mapFormulariosSalida(data:any[]){
    if(!data) return null;
    return data.map(({
      // id,
      pagina,
      nombre,
      orden,
      posicionHeight,
      posicionLeft,
      posicionRight,
      posicionTop,
      posicionWidth,
      valorOpcionSeleccionada,
      obligatorio}) =>
     ({
      // Id: id,
      Pagina: pagina,
      Nombre: nombre,
      Orden: orden,
      PosicionHeight: ((posicionHeight ?? 0) * 100),
      PosicionLeft: ((posicionLeft ?? 0) * 100),
      PosicionRight: ((posicionRight ?? 0) * 100),
      PosicionTop: ((posicionTop ?? 0) * 100),
      PosicionWidth: ((posicionWidth ?? 0) * 100),
      NombreValorCheck: valorOpcionSeleccionada,
      Obligatorio: obligatorio
    }))
  }

  mapFirmasSalida(data: any){
    if(!data) return null;
    const newObject = { NombreCertificado: data.nombreCertificado, NombreTag: data.nombreTag, PosicionFirmas: this.mapCoordenadasSimpleSalida(data.posicionFirmas), TieneTag: data.tieneTag, TipoFirma: data.tipoFirma};
    return newObject;
  }
  // mapFirmasSalida(data: any){
  //   if(!data) return null;
  //   const newObject = { NombreCertificado: data.nombreCertificado, NombreTag: data.nombreTag, PosicionFirmas: data.posicionFirmas, TieneTag: data.tieneTag, TipoFirma: data.tipoFirma};
  //   return newObject;
  // }

  mapTiposContenidoSalida(data:any[]){
    if(!data) return null;
    return data.map(
      ({
        // id,
        pagina,
        tipo,
        posicionHeight,
        posicionLeft,
        posicionRight,
        posicionTop,
        posicionWidth,
        identificador,
        nombre
      }) =>
      ({
        // Id: id,
        Pagina: pagina,
        Tipo: this.mapTiposContenidoTipoSalida(tipo),
        PosicionHeight: ((posicionHeight ?? 0) * 100),
        PosicionLeft: ((posicionLeft ?? 0) * 100),
        PosicionRight: ((posicionRight ?? 0) * 100),
        PosicionTop: ((posicionTop ?? 0) * 100),
        PosicionWidth: ((posicionWidth ?? 0) * 100),
        NombreCampoTexto:nombre,
        Nombre:identificador,
      }))
  }

  mapTiposContenidoTipoSalida(data: any){
    if(!data) return null;
    const newObject = { Id: data.id, Nombre: data.nombre};
    return newObject;
  }

  mapTiposContenidoEntrada(data:any[]){
    if(!data) return null;
    return data.map(
      ({
        // IdPosicionFirma,
        Pagina,
        Tipo,
        PosicionHeight,
        PosicionLeft,
        PosicionRight,
        PosicionTop,
        PosicionWidth,
        NombreCampoTexto,
        Nombre
      }) =>
      ({
        // id: IdPosicionFirma,
        pagina: Pagina,
        tipo: this.mapTiposContenidoTipoEntrada(Tipo),
        posicionHeight: ((PosicionHeight ?? 0) / 100),
        posicionLeft: ((PosicionLeft ?? 0) / 100),
        posicionRight: ((PosicionRight ?? 0) / 100),
        posicionTop: ((PosicionTop ?? 0) / 100),
        posicionWidth: ((PosicionWidth ?? 0) / 100),
        nombre: NombreCampoTexto,
        identificador: Nombre
    }))
  }

  mapTiposContenidoTipoEntrada(data:any){
    if(!data) return null;
    else if (Array.isArray(data)) return data.map(({Id, Nombre})=>({id: Id, nombre: Nombre}))
    else return {id: data.Id, nombre: data.Nombre};
  }

  convertir0ANull(datos:any[]):any[]{
    if(!datos) return null;
    datos.map(x => {
      if(x.recordatorios == 0) x.recordatorios = null;
      if(x.numeroAdjuntos == 0) x.numeroAdjuntos = null;
      if(x.documentosEnvioProgramado == 0) x.documentosEnvioProgramado = null;
      // if(x.diasRecordatorio == 0) x.diasRecordatorio = null
    })
    return datos
  }

  mapDocumentosEntrada(response: any[]){
    if(!response) return null;
    let documentos = response.map(({
                          Activo,
                          CifOrden,
                          CifPage,
                          CifFormulario,
                          Fusionable,
                          Generico,
                          IdTipoDocumento,
                          IdV3TipoDocumento,
                          Nombre,
                          NombreEnvio,
                          OrdenFusion,
                          Paginas,
                          Texto,
                          TextoFormulario,
                          TextoAExcluir,
                          TextoAExcluirFormulario,
                          TiposContenido,
                          FirmantesNif,
                          IdPdf,
                          EsCopiaBasica,
                          FormatoNombreArchivoAuditTrail,
                          FormatoNombreArchivoFirmado,
                          Split,
                          NombreDocumentoGenerico,
                          EsRLT
                        }) => ({
                          activo: Activo,
                          cifOrden: CifOrden,
                          cifPage: CifPage,
                          cifFormulario:CifFormulario,
                          fusionable: Fusionable,
                          generico: Generico,
                          idTipoDocumento: IdTipoDocumento,
                          idV3TipoDocumento: IdV3TipoDocumento,
                          nombre: Nombre,
                          nombreEnvio: NombreEnvio,
                          ordenFusion: OrdenFusion,
                          paginas: Paginas,
                          texto: Texto,
                          textoFormulario:TextoFormulario,
                          textoAExcluir: TextoAExcluir,
                          textoAExcluirFormulario:TextoAExcluirFormulario,
                          tiposContenido: this.mapTiposContenidoEntrada(TiposContenido),
                          firmantesNif: this.mapFirmantesNifEntrada(FirmantesNif),
                          idPdf: IdPdf,
                          esCopiaBasica: EsCopiaBasica,
                          formatoNombreArchivoAuditTrail: FormatoNombreArchivoAuditTrail,
                          formatoNombreArchivoFirmado: FormatoNombreArchivoFirmado,
                          split: Split,
                          nombreDocumentoGenerico: NombreDocumentoGenerico,
                          esRLT: EsRLT
                        }));
      return documentos;
  }

  mapDocumentosSalida(data:any){
    if(!data) return null;
    const {cifOrden: CifOrden,
          cifPage: CifPage,
          cifFormulario:CifFormulario,
          //contieneCif: ContieneCif,
          //copyConfiguracion: CopyConfiguracion,
          fusionable: Fusionable,
          ordenFusion: OrdenFusion,
          firmantesNif: FirmantesNif,
          generico: Generico,
          //idTipoDocOrigen: IdTipoDocOrigen,
          idTipoDocumento: IdTipoDocumento,
          //incluirContenido: IncluirContenido,
          nombre: Nombre,
          texto: Texto,
          textoFormulario:TextoFormulario,
          textoAExcluir: TextoAExcluir,
          textoAExcluirFormulario:TextoAExcluirFormulario,
          tiposContenido: TiposContenido,
          paginas: Paginas,
          activo: Activo,
          idPdf: IdPdf,
          esCopiaBasica: EsCopiaBasica,
          formatoNombreArchivoAuditTrail: FormatoNombreArchivoAuditTrail,
          formatoNombreArchivoFirmado: FormatoNombreArchivoFirmado,
          split: Split,
          nombreDocumentoGenerico: NombreDocumentoGenerico,
          esRLT: EsRLT
          //urlDocTemp
         } = data;
   const newObject = {
                      CifOrden,
                      CifPage,
                      CifFormulario,
                      Fusionable,
                      OrdenFusion,
                      FirmantesNif,
                      Generico,
                      IdTipoDocumento,
                      Nombre,
                      Texto,
                      TextoFormulario,
                      TextoAExcluir,
                      TextoAExcluirFormulario,
                      TiposContenido,
                      Paginas,
                      Activo,
                      IdPdf,
                      EsCopiaBasica,
                      FormatoNombreArchivoAuditTrail,
                      FormatoNombreArchivoFirmado,
                      Split,
                      NombreDocumentoGenerico,
                      EsRLT
                      }

    return newObject
  }

  mapFirmantesNifSalida(firmantes:any[]){
    if(!firmantes) return null;
    firmantes.forEach(element => {
      element.tipoBusqueda = {codigo: 'documento', desc: 'documento'};
      if (element.firmas.tipoFirma == TipoFirma.Validador) {
        element.firmas.tipoFirma = "validator";
        element.tipoDestinatario = {codigo: 'validator', desc: 'Validador'};
      }
      else {
        element.tipoDestinatario = {codigo: 'signer', desc: 'signer'};
        if(element.firmas.tipoFirma == TipoFirma.Certificado) element.firmas.tipoFirma = "dcf";
        else if(element.firmas.tipoFirma == TipoFirma.Validador) element.firmas.tipoFirma = "validator";
        else if(element.firmas.tipoFirma == TipoFirma.Dibujada) element.firmas.tipoFirma = "signer";
        else if(element.firmas.tipoFirma == TipoFirma.SinFirma) element.firmas.tipoFirma = "";
      }
      element.firmas.tieneTag = element.firmas.tieneTag == true; // hay casos en los que aparece como null y da problemas
      if(element.nifOrden==null ) element.nifOrden=0;
      if(element.nifPage==null ) element.nifPage=0;
    });

    return firmantes.map(({
      firmas,
      nifOrden,
      nifPage,
      nifFormulario,
      tipoFirmante,
      formularios,
      camposEditables,
      tipoBusqueda,
      tipoDestinatario,
      orden
    })=>({
      Firmas: this.mapFirmasSalida(firmas),
      NifOrden: nifOrden,
      NifPage: nifPage,
      NifFormulario:nifFormulario,
      Orden: orden ?? 0,
      TipoFirmante: this.mapTiposEnvioDesplegablesSalida(tipoFirmante),
      Formularios: this.mapFormulariosSalida(formularios),
      CamposEditables: this.mapCoordenadasSimpleSalida(camposEditables),
      TipoBusqueda: this.mapTiposEnvioDesplegablesSalida(tipoBusqueda),
      TipoDestinatario: this.mapTiposEnvioDesplegablesSalida(tipoDestinatario)
    }));
    // return firmantes.map(({
    //   firmas,
    //   nifOrden,
    //   nifPage,
    //   nifFormulario,
    //   tipoFirmante,
    //   formularios,
    //   camposEditables,
    //   tipoBusqueda,
    //   tipoDestinatario
    // })=>({
    //   Firmas: firmas,
    //   NifOrden: nifOrden,
    //   NifPage: nifPage,
    //   NifFormulario:nifFormulario,
    //   TipoFirmante: tipoFirmante,
    //   Formularios: formularios,
    //   CamposEditables: camposEditables,
    //   TipoBusqueda: this.mapTiposEnvioDesplegablesSalida(tipoBusqueda),
    //   TipoDestinatario: this.mapTiposEnvioDesplegablesSalida(tipoDestinatario)
    // }));
  }

  mapFirmantesNifEntrada(data: any[]){
    if(!data) return null;
    return data.map(({
      TipoBusqueda,
      TipoDestinatario,
      TipoFirmante,
      CamposEditables,
      Firmas,
      Formularios,
      NifOrden,
      NifPage,
      NifFormulario,
      Orden
    }) => ({
      tipoBusqueda: this.mapTiposEnvioDesplegablesEntradaSingle(TipoBusqueda),
      tipoDestinatario: this.mapTiposEnvioDesplegablesEntradaSingle(TipoDestinatario),
      tipoFirmante: this.mapTiposEnvioDesplegablesEntradaSingle(TipoFirmante),
      camposEditables: this.mapCamposEditablesEntrada(CamposEditables),
      firmas: this.mapFirmasEntrada(Firmas),
      formularios: this.mapFormulariosEntrada(Formularios),
      nifOrden: NifOrden,
      nifPage: NifPage,
      nifFormulario:NifFormulario,
      orden: Orden
    }));
  }

  mapCamposEditablesEntrada(response: any[]){
    if(!response) return null;
    return response.map(({
      AlturaTagFirma,
      AnchuraTagFirma,
      EsFirmaTag,
      EsTextoEditable,
      IdPosicionFirma,
      IdTipoDocumento,
      Nombre,
      Orden,
      Pagina,
      PosicionHeight,
      PosicionLeft,
      PosicionTop,
      PosicionWidth,
      PosicionRight,
      Tag,
      TextoPorDefecto,
      TipoFirma,
      NombreCampoTexto,
      Obligatorio
    })=>({
      // id: IdPosicionFirma,
      pagina: Pagina,
      posicionHeight: ((PosicionHeight ?? 0) / 100),
      posicionLeft: ((PosicionLeft ?? 0) / 100),
      posicionRight: ((PosicionRight ?? 0) / 100),
      posicionTop: ((PosicionTop ?? 0) / 100),
      posicionWidth: ((PosicionWidth ?? 0) / 100),
      identificador: Nombre,
      nombreCampo: NombreCampoTexto,
      valorPorDefecto: TextoPorDefecto,
      obligatorio: Obligatorio
    }))
  }

  mapFirmasEntrada(data:any){
    if(!data) return null;
    const newObject = {
                nombreCertificado: data.NombreCertificado,
                nombreTag: data.NombreTag,
                posicionFirmas: this.mapPosicionFirmasEntrada(data.PosicionFirmas),
                tieneTag: data.TieneTag,
                tipoFirma: data.TipoFirma
              };
    return newObject;
  }

  mapPosicionFirmasEntrada(response:any[]){
    if(!response) return null;
    return response.map(({
      AlturaTagFirma,
      AnchuraTagFirma,
      EsFirmaTag,
      EsTextoEditable,
      IdPosicionFirma,
      IdTipoDocumento,
      Nombre,
      Orden,
      Pagina,
      PosicionHeight,
      PosicionLeft,
      PosicionTop,
      PosicionWidth,
      PosicionRight,
      Tag,
      TextoPorDefecto,
      TipoFirma
    })=>({
      id: IdPosicionFirma,
      pagina: Pagina,
      posicionHeight: ((PosicionHeight ?? 0) / 100),
      posicionLeft: ((PosicionLeft ?? 0) / 100),
      posicionRight: ((PosicionRight ?? 0) / 100),
      posicionTop: ((PosicionTop ?? 0) / 100),
      posicionWidth: ((PosicionWidth ?? 0) / 100)
    }))
  }

  mapFormulariosEntrada(response: any[]){
    if(!response) return null;
    return response.map(({
      AlturaTagFirma,
      AnchuraTagFirma,
      EsFirmaTag,
      EsTextoEditable,
      IdPosicionFirma,
      IdTipoDocumento,
      Nombre,
      Orden,
      Pagina,
      PosicionHeight,
      PosicionLeft,
      PosicionTop,
      PosicionWidth,
      PosicionRight,
      Tag,
      TextoPorDefecto,
      TipoFirma,
      NombreValorCheck,
      Obligatorio
    })=>({
      // id: IdPosicionFirma,
      pagina: Pagina,
      nombre: Nombre,
      orden: Orden,
      posicionHeight: ((PosicionHeight ?? 0) / 100),
      posicionLeft: ((PosicionLeft ?? 0) / 100),
      posicionRight: ((PosicionRight ?? 0) / 100),
      posicionTop: ((PosicionTop ?? 0) / 100),
      posicionWidth: ((PosicionWidth ?? 0) / 100),
      valorOpcionSeleccionada: NombreValorCheck,
      obligatorio: Obligatorio
    }))
  }

  // mapTiposContenidoEntrada(response: any[]){
  //   return response.map(({
  //     AlturaTagFirma,
  //     AnchuraTagFirma,
  //     EsFirmaTag,
  //     EsTextoEditable,
  //     IdPosicionFirma,
  //     IdTipoDocumento,
  //     Nombre,
  //     Orden,
  //     Pagina,
  //     PosicionHeight,
  //     PosicionLeft,
  //     PosicionTop,
  //     PosicionWidth,
  //     Tag,
  //     TextoPorDefecto,
  //     Tipo,
  //     TipoFirma
  //   })=>({
  //     pagina: Pagina,
  //     tipo: this.mapTiposContenidoTipoEntradaSingle(Tipo),
  //     posicionTop: PosicionTop,
  //     posicionLeft: PosicionLeft,
  //     // posicionRight: PosicionRight,
  //     posicionWidth: PosicionWidth,
  //     posicionHeight: PosicionHeight
  //   }))

  // }

  mapTiposContenidoTipoEntradaSingle(data: any){
    if(!data) return null;
    const newObject = {
                id: data.Id,
                nombre: data.Nombre
              };
    return newObject;
  }

  mapCentrosEntrada(response: any[]){
    if(!response) return null;
    return response.map(({
                          CodigoCentro,
                          NombreCentro,
                          EmailCentro,
                          CodigoEmpresa,
                          NombreEmpresa,
                          NombreRlt,
                          DniRlt
                          })=>({
                          codigoCentro: CodigoCentro,
                          nombreCentro: NombreCentro,
                          emailCentro: EmailCentro,
                          codigoEmpresa: CodigoEmpresa,
                          nombreEmpresa: NombreEmpresa,
                          nombreRlt: NombreRlt,
                          dniRlt: DniRlt
                          }))
  }

  mapCentrosSalida(data: any){
    if(!data) return null;
   const{ codigoCentro: CodigoCentro,
          nombreCentro: NombreCentro,
          emailCentro: EmailCentro,
          codigoEmpresa: CodigoEmpresa,
          nombreEmpresa: NombreEmpresa,
          nombreRlt: NombreRlt,
          dniRlt: DniRlt
        } = data;
   const newObject = {
                      CodigoCentro,
                      NombreCentro,
                      EmailCentro,
                      CodigoEmpresa,
                      NombreEmpresa,
                      NombreRlt,
                      DniRlt
                      }

    return newObject
  }

  mapEmpresasEntrada(response: any[]){
    if(!response) return null;
    return response.map(({
                          Apellido1Empleado,
                          Apellido2Empleado,
                          // BrandinId,
                          Centros,
                          Cif,
                          CodigoEmpresa,
                          EmailCopia,
                          EmailEmpleado,
                          Logo,
                          // NombreCopia,
                          NombreEmpleado,
                          NombreEmpresa,
                          TipoDocumento,
                          // Token
                          })=>({
                          codigoEmpresa: CodigoEmpresa,
                          tipoDocumento: TipoDocumento,
                          cif: Cif,
                          nombreEmpresa: NombreEmpresa,
                          nombreEmpleado: NombreEmpleado,
                          emailEmpleado: EmailEmpleado,
                          apellido1Empleado: Apellido1Empleado,
                          apellido2Empleado: Apellido2Empleado,
                          logo: Logo,
                          centros: this.mapCentrosEntrada(Centros)
                          }))
  }

  mapEmpresasSalida(data: any){
    if(!data) return null;
   const{ codigoEmpresa: CodigoEmpresa,
          tipoDocumento: TipoDocumento,
          cif: Cif,
          nombreEmpresa: NombreEmpresa,
          nombreEmpleado: NombreEmpleado,
          emailEmpleado: EmailEmpleado,
          apellido1Empleado: Apellido1Empleado,
          apellido2Empleado: Apellido2Empleado,
          logog: Logo,
          token: Token,
          brandId: BrandinId,
          emailCopia: EmailCopia,
          nombreCopia: NombreCopia,
          centros: Centros
        } = data;
   const newObject = {
                      CodigoEmpresa,
                      TipoDocumento,
                      Cif,
                      NombreEmpresa,
                      NombreEmpleado,
                      EmailEmpleado,
                      Apellido1Empleado,
                      Apellido2Empleado,
                      Logo,
                      Token,
                      BrandinId,
                      EmailCopia,
                      NombreCopia,
                      Centros
                      }

    return newObject
  }

//USERS

  mapUsersEntrada(response: any[]){
    if(!response) return null;
    return response.map(({
      Login,
      LoginOld,
      Password,
      PasswordOld,
      ClientId,
      Nombre,
      Apellido1,
      Rol,
      UltimaConexion,
      InvitacionEnviada,
      UsuarioActivo,
      TokenInvitacion,
      FechaInvitacion,
      InvitacionAceptada,
      AzureAdObjectId,
      AplicationId,
      TipoSeguridad,
      TipoEnvioPermitido,
      EmpresaPermitida,
      CentroPermitido,
      UsuarioA3Trans,
      Tenant,
      MultiTenant,
      FiltroSeguridadFirmas,
      PasswordA3,
      TieneMfa

     })=>({
      email: Login,
      loginOld: LoginOld,
      password: Password,
      passwordOld: PasswordOld,
      azureAdObjectId: AzureAdObjectId,
      tokenInvitacion: TokenInvitacion,
      tipoSeguridad: TipoSeguridad,
      nombre: Nombre,
      apellido1: Apellido1,
      rol: Rol,
      usuarioActivo: UsuarioActivo,
      tipoEnvioPermitido: TipoEnvioPermitido,
      empresaPermitida: EmpresaPermitida,
      centroPermitido: CentroPermitido,
      usuarioA3Trans: UsuarioA3Trans,
      tenant: Tenant,
      multiTenant: MultiTenant,
      filtroSeguridadFirmas: FiltroSeguridadFirmas,
      invitacionAceptada: InvitacionAceptada,
      invitacionEnviada: InvitacionEnviada,
      passwordA3: PasswordA3,
      tieneMfa: TieneMfa
     }))
  }

  mapGuardaUserSalida(data:any){
    if(!data) return null;
    const {
          apellido1: Apellido1,
          centroPermitido: CentroPermitido,
          email: Login,
          empresaPermitida: EmpresaPermitida,
          nombre: Nombre,
          rol: Rol,
          tipoEnvioPermitido: TipoEnvioPermitido,
          usuarioActivo: UsuarioActivo,
          loginOld: LoginOld,
          password: Password,
          passwordOld: PasswordOld,
          azureAdObjectId: AzureAdObjectId,
          tokenInvitacion: TokenInvitacion,
          tipoSeguridad: TipoSeguridad,
          usuarioA3Trans: UsuarioA3Trans,
          tenant: Tenant,
          multiTenant: MultiTenant,
          filtroSeguridadFirmas: FiltroSeguridadFirmas,
          invitacionAceptada: InvitacionAceptada,
          invitacionEnviada: InvitacionEnviada,
          passwordA3: PasswordA3,
          tieneMfa: TieneMfa
         } = data;
   const newObject = {
                      Apellido1,
                      CentroPermitido,
                      Login,
                      EmpresaPermitida,
                      Nombre,
                      Rol,
                      TipoEnvioPermitido,
                      UsuarioActivo,
                      LoginOld,
                      Password,
                      PasswordOld,
                      AzureAdObjectId,
                      TokenInvitacion,
                      TipoSeguridad,
                      UsuarioA3Trans,
                      Tenant,
                      MultiTenant,
                      FiltroSeguridadFirmas,
                      InvitacionAceptada,
                      InvitacionEnviada,
                      PasswordA3,
                      TieneMfa
                      }

    return newObject
  }

  mapSeguridadPermitidaEntrada(data: any){
    if(!data) return null;
    let newObject;
    if(data.CodigoEmpresa){
      newObject = {
        id: data.Id,
        desc: data.Desc,
        codigoEmpresa: data.CodigoEmpresa
      };
    }else{
      newObject = {
        id: data.Id,
        desc: data.Desc
      };
    }
    if(newObject.desc==null) newObject.desc='';
    return newObject;
  }

  mapSeguridadPermitidaSalida(data:any){
    if(!data) return null;
    let newObject;
    if(data.codigoEmpresa){
      const{id:Id, desc: Desc, codigoEmpresa: CodigoEmpresa} = data;
      newObject = {Id, Desc, CodigoEmpresa};
    }else{
      const{id:Id, desc: Desc} = data;
      newObject = {Id, Desc};
    }
    return newObject;
  }

  //CONFIGURACION RLT

  mapConfiguracionRltEntrada(data: any){
    if(!data) return null;

    const newObject = {
                        activo: data.Activo,
                        idTipoDosier: data.idTipoDosier,
                        // idTipoDosierV3: '',//data.IdTipoDosierV3,
                        periodicidad: data.Periodicidad,
                        diaEnvio: data.DiaEnvio,
                        hora: data.Hora,
                        cadaDia: data.CadaDia,
                        diaMes: data.DiaMes,
                        primerUltimoDia: data.PrimerUltimoDia,
                        tipoDia: data.TipoDia,
                        activo_noFirmados: data.Activo_NoFirmados,
                        idTipoDosier_noFirmados: data.idTipoDosier_NoFirmados,
                        periodicidad_noFirmados: data.Periodicidad_NoFirmados,
                        diaEnvio_noFirmados: data.DiaEnvio_NoFirmados,
                        hora_noFirmados: data.Hora_NoFirmados,
                        cadaDia_noFirmados: data.CadaDia_NoFirmados,
                        diaMes_noFirmados: data.DiaMes_NoFirmados,
                        primerUltimoDia_noFirmados: data.PrimerUltimoDia_NoFirmados,
                        tipoDia_noFirmados: data.TipoDia_NoFirmados,
                        diasRetraso_noFirmados: data.DiasRetraso_NoFirmados
                        }
    return newObject
  }

  mapConfiguracionRltSalida(data:any){
    if(!data) return null;
    const {
          activo: Activo,
          idTipoDosier: idTipoDosier,
          // idTipoDosierV3: IdTipodosierV3,
          periodicidad: Periodicidad,
          diaEnvio: DiaEnvio,
          hora: Hora,
          cadaDia: CadaDia,
          diaMes: DiaMes,
          primerUltimoDia: PrimerUltimoDia,
          tipoDia: TipoDia,
          activo_noFirmados: Activo_NoFirmados,
          idTipoDosier_noFirmados: idTipoDosier_NoFirmados,
          periodicidad_noFirmados: Periodicidad_NoFirmados,
          diaEnvio_noFirmados: DiaEnvio_NoFirmados,
          hora_noFirmados: Hora_NoFirmados,
          cadaDia_noFirmados: CadaDia_NoFirmados,
          diaMes_noFirmados: DiaMes_NoFirmados,
          primerUltimoDia_noFirmados: PrimerUltimoDia_NoFirmados,
          tipoDia_noFirmados: TipoDia_NoFirmados,
          diasRetraso_noFirmados: DiasRetraso_NoFirmados
         } = data;
   const newObject = {
                      Activo,
                      idTipoDosier,
                      // IdTipodosierV3,
                      Periodicidad,
                      DiaEnvio,
                      Hora,
                      CadaDia,
                      DiaMes,
                      PrimerUltimoDia,
                      TipoDia,
                      Activo_NoFirmados,
                      idTipoDosier_NoFirmados,
                      Periodicidad_NoFirmados,
                      DiaEnvio_NoFirmados,
                      Hora_NoFirmados,
                      CadaDia_NoFirmados,
                      DiaMes_NoFirmados,
                      PrimerUltimoDia_NoFirmados,
                      TipoDia_NoFirmados,
                      DiasRetraso_NoFirmados
                      }

    if(newObject.Hora=='') newObject.Hora = '00:00';
    if(newObject.Hora_NoFirmados=='') newObject.Hora_NoFirmados = '00:00';
    return newObject
  }

  mapEmpleadosEntrada(response: any[]){
    if(!response) return null;
    return response.map(({
      APELLIDO1,
      APELLIDO2,
      CENTRO,
      CODIGO,
      CODIGO_EXTERNO,
      CODIGO_POSTAL,
      DESCRIPCION_CATEGORIA,
      DESCRIPCION_CONVENIO,
      DESCRIPCION_PUESTO_TRABAJO,
      EMPRESA,
      EMPRESA_CIF,
      EMPRESA_NOMBRE,
      ESCALERA,
      ESTADO_CIVIL,
      EXTENSION_TELEFONO_PERSONAL,
      EXTENSION_TELEFONO_PROFESIONAL,
      FECHA_ALTA,
      FECHA_NACIMIENTO,
      LUGAR_NACIMIENTO,
      MAIL_PERSONAL,
      MAIL_PROFESIONAL,
      MUNICIPIO,
      NACIONALIDAD,
      NIF,
      NOMBRE,
      NOMBRE_CENTRO,
      NUMERO,
      PISO,
      PROVINCIA,
      PUERTA,
      SEXO,
      SIGLA,
      TELEFONO_PESONAL,
      TELFONO_PROFESIONAL,
      TIPO_DOCUMENTO,
      TIPO_PERSONA
     })=>({
      codigo: CODIGO,
      nombre: NOMBRE,
      apellido1: APELLIDO1,
      apellido2: APELLIDO2,
      tipoDocumento: TIPO_DOCUMENTO,
      nif: NIF,
      fechaNacimiento: FECHA_NACIMIENTO,
      mailPersonal: MAIL_PERSONAL,
      nacionalidad: NACIONALIDAD,
      lugarNacimiento: LUGAR_NACIMIENTO,
      fechaAlta: FECHA_ALTA,
      empresaCif: EMPRESA_CIF,
      estadoCivil: ESTADO_CIVIL,
      sexo: SEXO,
      tipoPersona: TIPO_PERSONA,
      sigla: SIGLA,
      provincia: PROVINCIA,
      municipio: MUNICIPIO,
      codigoPostal: CODIGO_POSTAL,
      numero: NUMERO,
      escalera: ESCALERA,
      piso: PISO,
      puerta: PUERTA,
      extensionTelefonoPersonal: EXTENSION_TELEFONO_PERSONAL,
      extensionTelefonoProfesional: EXTENSION_TELEFONO_PROFESIONAL,
      puestoTrabajo: DESCRIPCION_PUESTO_TRABAJO,
      categoria: DESCRIPCION_CATEGORIA,
      convenio: DESCRIPCION_CONVENIO,
      codigoEmpresa: EMPRESA,
      nombreEmpresa: EMPRESA_NOMBRE,
      codigoCentro: CENTRO,
      telefonoPersonal: TELEFONO_PESONAL,
      mailProfesional: MAIL_PROFESIONAL,
      telefonoProfesional: TELFONO_PROFESIONAL,
      nombreCentro: NOMBRE_CENTRO,
      codigoExterno: CODIGO_EXTERNO
     }))
  }

  mapUpdateEmpleadoSalida(data:any){
    if(!data) return null;
    const {
          codigo: CODIGO,
          nombre: NOMBRE,
          apellido1: APELLIDO1,
          apellido2: APELLIDO2,
          tipoDocumento: TIPO_DOCUMENTO,
          nif: NIF,
          fechaNacimiento: FECHA_NACIMIENTO,
          mailPersonal: MAIL_PERSONAL,
          nacionalidad: NACIONALIDAD,
          lugarNacimiento: LUGAR_NACIMIENTO,
          fechaAlta: FECHA_ALTA,
          empresaCif: EMPRESA_CIF,
          estadoCivil: ESTADO_CIVIL,
          sexo: SEXO,
          tipoPersona: TIPO_PERSONA,
          sigla: SIGLA,
          provincia: PROVINCIA,
          municipio: MUNICIPIO,
          codigoPostal: CODIGO_POSTAL,
          numero: NUMERO,
          escalera: ESCALERA,
          piso: PISO,
          puerta: PUERTA,
          extensionTelefonoPersonal: EXTENSION_TELEFONO_PERSONAL,
          extensionTelefonoProfesional: EXTENSION_TELEFONO_PROFESIONAL,
          puestoTrabajo: DESCRIPCION_PUESTO_TRABAJO,
          categoria: DESCRIPCION_CATEGORIA,
          convenio: DESCRIPCION_CONVENIO,
          codigoEmpresa: EMPRESA,
          nombreEmpresa: EMPRESA_NOMBRE,
          codigoCentro: CENTRO,
          telefonoPersonal: TELEFONO_PESONAL,
          mailProfesional: MAIL_PROFESIONAL,
          telefonoProfesional: TELFONO_PROFESIONAL,
          nombreCentro: NOMBRE_CENTRO,
          codigoExterno: CODIGO_EXTERNO
         } = data;
   const newObject = {
                      CODIGO,
                      NOMBRE,
                      APELLIDO1,
                      APELLIDO2,
                      TIPO_DOCUMENTO,
                      NIF,
                      FECHA_NACIMIENTO,
                      MAIL_PERSONAL,
                      NACIONALIDAD,
                      LUGAR_NACIMIENTO,
                      FECHA_ALTA,
                      EMPRESA_CIF,
                      ESTADO_CIVIL,
                      SEXO,
                      TIPO_PERSONA,
                      SIGLA,
                      PROVINCIA,
                      MUNICIPIO,
                      CODIGO_POSTAL,
                      NUMERO,
                      ESCALERA,
                      PISO,
                      PUERTA,
                      EXTENSION_TELEFONO_PERSONAL,
                      EXTENSION_TELEFONO_PROFESIONAL,
                      DESCRIPCION_PUESTO_TRABAJO,
                      DESCRIPCION_CATEGORIA,
                      DESCRIPCION_CONVENIO,
                      EMPRESA,
                      EMPRESA_NOMBRE,
                      CENTRO,
                      TELEFONO_PESONAL,
                      MAIL_PROFESIONAL,
                      TELFONO_PROFESIONAL,
                      NOMBRE_CENTRO,
                      CODIGO_EXTERNO
                      }

    return newObject
  }

  mapCodigoAIdEntrada(response:any[]){
    if(!response) return null;
    return response.map(({codigo, desc})=>({id: codigo, desc: desc}))
  }

  conversionEstadoSalida(estado:string):string{
    switch(estado){
      case 'TODOS': return '';
      case 'BORRADOR': return 'Pendiente';
      case 'FIRMADO': return 'Firmado';
      case 'PARCIALMENTE FIRMADO': return 'Parcialmente Firmado';
      case 'RECHAZADO': return 'Rechazado';
      case 'NO FIRMADO': return 'No Firmado';
      case 'CADUCADO': return 'Caducado';
      case 'ERROR': return 'Error';
      case 'CANCELADO': return 'Cancelado';
      default: return '';
    }
  }

  mapFormulariosInfoEntrada(response: any[]){
    if(!response) return null;
    return response.map(({
                          IdTipoDocumento,
                          Version,
                          NombreTipoDocumento,
                          Firmas
                          })=>({
                          idTipoDocumento: IdTipoDocumento,
                          version: Version,
                          nombre: NombreTipoDocumento,
                          cantidad: Firmas,
                          seleccionado: false
                          }))
  }

  mapFormulariosInfoSalida(data:any){
    if(!data) return null;
    const {idTipoDocumento, version, nombre, cantidad} = data;
    return {IdTipoDocumento: idTipoDocumento, Version: version, NombreTipoDocumento: nombre, Firmas: cantidad}
  }

  /**
   * Mapea el estado front del wizard Envio simple al contrato POST `api/Envios/ProcesaEnvioSimple`.
   * Reutiliza `mapDocumentosSalida`, `mapFirmantesNifSalida` y `mapTiposContenidoSalida`.
   */
  mapProcesaEnvioSimpleSalida(
    estado: EnvioSimpleEstadoFlujoSalida,
    opciones: OpcionesMapProcesaEnvioSimpleSalida = {}
  ): ProcesaEnvioSimpleRequest {
    const documentosOrdenados = [...estado.documentos].sort(
      (a, b) => a.documento.orden - b.documento.orden
    );

    return {
      VersionContrato: opciones.versionContrato ?? VERSION_CONTRATO_PROCESA_ENVIO_SIMPLE,
      Wait: opciones.wait ?? true,
      IsEnvioTest: opciones.isEnvioTest ?? false,
      Documentos: documentosOrdenados.map(item =>
        this.mapDocumentoProcesaEnvioSimpleSalida(item.documento, item.formularioDocumento)
      ),
      Firmantes: this.mapFirmantesProcesaEnvioSimpleSalida(estado.firmantesEnvio),
      Canales: {
        EnvioMail: estado.canales.envioMail,
        EnvioSMS: estado.canales.envioSMS
      },
      Mensaje: {
        Subject: estado.mensajeCorreo.subject ?? '',
        Body: estado.mensajeCorreo.body ?? ''
      },
      Ajustes: {
        Recordatorio: estado.ajustesEnvio.recordatorio,
        Recordatorios: estado.ajustesEnvio.recordatorios.filter(
          (valor): valor is number => valor != null
        ),
        Caducidad: estado.ajustesEnvio.caducidad,
        EnvioParalelo: estado.ajustesEnvio.envioParalelo
      },
      Metadata: {
        TipoEnvioSeleccionado: estado.tipoEnvio ?? 'ENVIO_SIMPLE',
        FechaSolicitudCliente: opciones.fechaSolicitudCliente ?? new Date().toISOString()
      }
    };
  }

  private mapDocumentoProcesaEnvioSimpleSalida(
    documento: DocumentoEnvioSimple,
    formularioDocumento: FormGroup
  ): ProcesaEnvioSimpleDocumentoRequest {
    const configuracion = this.mapConfiguracionDocumentoProcesaEnvioSimpleSalida(
      formularioDocumento,
      documento
    );
    const idTipoDocumento =
      documento.idTipoDocumento ??
      formularioDocumento.get('idTipoDocumento')?.value ??
      null;

    return {
      Id: documento.id,
      Nombre: documento.nombre,
      Orden: documento.orden,
      Origen: documento.origen,
      IdFicheroTemporal: this.resolverIdFicheroTemporalProcesaEnvioSimple(documento, formularioDocumento),
      IdTipoDocumento: idTipoDocumento,
      Configuracion: configuracion
    };
  }

  private mapConfiguracionDocumentoProcesaEnvioSimpleSalida(
    formularioDocumento: FormGroup,
    documento: DocumentoEnvioSimple
  ): Record<string, unknown> {
    const objetoDocumento = this.extraerObjetoDocumentoDesdeFormulario(formularioDocumento, documento);
    let configuracion = this.mapDocumentosSalida(objetoDocumento) as Record<string, unknown> | null;

    if (!configuracion) {
      return {};
    }

    const firmantesNif = configuracion.FirmantesNif as unknown[] | undefined;
    if (Array.isArray(firmantesNif) && firmantesNif.length > 0) {
      configuracion.FirmantesNif = this.mapFirmantesNifSalida(firmantesNif as FirmanteNif[]);
    }

    const tiposContenido = configuracion.TiposContenido as unknown[] | undefined;
    if (Array.isArray(tiposContenido)) {
      configuracion.TiposContenido = this.mapTiposContenidoSalida(tiposContenido);
    }

    configuracion.NombreEnvio = documento.nombre;
    if (documento.idTipoDocumento != null) {
      configuracion.IdV3TipoDocumento = String(documento.idTipoDocumento);
    }

    return configuracion;
  }

  /**
   * Extrae el objeto documento en camelCase (misma forma que `montarObjetoDocumentoGuardar`)
   * a partir del FormGroup almacenado en el flujo Envio simple.
   */
  private extraerObjetoDocumentoDesdeFormulario(
    formularioDocumento: FormGroup,
    documento: DocumentoEnvioSimple
  ): Record<string, unknown> {
    const tiposContenido: unknown[] = [];
    const tiposContenidoArray = formularioDocumento.get('tiposContenido') as FormArray | null;
    tiposContenidoArray?.controls.forEach(ctrl => {
      const row = ctrl as FormGroup;
      if (isPalabraRowColocada(row)) {
        tiposContenido.push(row.value);
      }
    });

    const firmantesNif: FirmanteNif[] = [];
    const firmantesArray = formularioDocumento.get('firmantesNif') as FormArray | null;
    firmantesArray?.controls.forEach(ctrl => {
      const firmanteGroup = ctrl as FormGroup;
      const formularios: PosicionFormulario[] = [];
      const formulariosArray = firmanteGroup.get('formularios') as FormArray | null;
      formulariosArray?.controls.forEach(formCtrl => {
        const row = formCtrl as FormGroup;
        if (isCasillaRowColocada(row)) {
          formularios.push(row.value as PosicionFormulario);
        }
      });

      const camposEditables: PosicionFormulario[] = [];
      const camposArray = firmanteGroup.get('camposEditables') as FormArray | null;
      camposArray?.controls.forEach(campoCtrl => {
        const row = campoCtrl as FormGroup;
        if (isCampoRowColocada(row)) {
          camposEditables.push(row.value as PosicionFormulario);
        }
      });

      firmantesNif.push({
        tipoFirmante: firmanteGroup.get('tipoFirmante')?.value,
        nifOrden: firmanteGroup.get('nifOrden')?.value,
        nifFormulario: firmanteGroup.get('nifFormulario')?.value,
        nifPage: firmanteGroup.get('nifPage')?.value,
        posicionNif: firmanteGroup.get('posicionNif')?.value ?? '',
        firmas: this.convierteFirmasDesdeFormulario(firmanteGroup.get('firmas') as FormGroup),
        formularios,
        camposEditables
      });
    });

    const nombre = (formularioDocumento.get('nombre')?.value as string | undefined)?.trim()
      ?? documento.nombre;

    return {
      cifOrden: formularioDocumento.get('cifOrden')?.value,
      cifPage: formularioDocumento.get('cifPage')?.value,
      cifFormulario: formularioDocumento.get('cifFormulario')?.value,
      fusionable: true,
      ordenFusion: documento.orden,
      firmantesNif,
      generico: formularioDocumento.get('generico')?.value ?? documento.generico ?? false,
      idTipoDocumento: formularioDocumento.get('idTipoDocumento')?.value ?? documento.idTipoDocumento ?? null,
      nombre,
      texto: formularioDocumento.get('texto')?.value,
      textoFormulario: formularioDocumento.get('textoFormulario')?.value,
      textoAExcluir: formularioDocumento.get('textoAExcluir')?.value,
      textoAExcluirFormulario: formularioDocumento.get('textoAExcluirFormulario')?.value,
      tiposContenido,
      paginas: formularioDocumento.get('paginas')?.value,
      activo: true,
      idPdf: formularioDocumento.get('idPdf')?.value,
      esCopiaBasica: formularioDocumento.get('esCopiaBasica')?.value,
      formatoNombreArchivoAuditTrail: formularioDocumento.get('formatoNombreArchivoAuditTrail')?.value,
      formatoNombreArchivoFirmado: formularioDocumento.get('formatoNombreArchivoFirmado')?.value,
      split: formularioDocumento.get('split')?.value,
      nombreDocumentoGenerico: documento.generico ? nombre : null,
      esRLT: formularioDocumento.get('esRLT')?.value
    };
  }

  private convierteFirmasDesdeFormulario(firmasGroup: FormGroup | null): ConfiguracionFirma {
    if (!firmasGroup) {
      return {
        tipoFirma: TipoFirma.SinFirma,
        nombreCertificado: '',
        tieneTag: false,
        nombreTag: '',
        posicionFirmas: []
      };
    }

    const posicionFirmas = firmasGroup.get('posicionFirmas') as FormArray | null;
    const colocadas =
      posicionFirmas?.controls
        ?.filter(row => isFirmaRowColocada(row as FormGroup))
        ?.map(row => (row as FormGroup).value) ?? [];
    const nombreCertificado = firmasGroup.get('nombreCertificado')?.value;

    return {
      tipoFirma: firmasGroup.get('tipoFirma')?.value,
      nombreCertificado:
        typeof nombreCertificado === 'string' ? nombreCertificado.trim() || null : nombreCertificado,
      tieneTag: firmasGroup.get('tieneTag')?.value,
      nombreTag: firmasGroup.get('nombreTag')?.value,
      posicionFirmas: colocadas
    };
  }

  private resolverIdFicheroTemporalProcesaEnvioSimple(
    documento: DocumentoEnvioSimple,
    formularioDocumento: FormGroup
  ): string | null {
    const idPdf = (formularioDocumento.get('idPdf')?.value as string | undefined)?.trim();
    if (idPdf) {
      return idPdf;
    }
    const urlDocTemp = (formularioDocumento.get('urlDocTemp')?.value as string | undefined)?.trim();
    return urlDocTemp || null;
  }

  private mapFirmantesProcesaEnvioSimpleSalida(
    firmantes: FirmanteEnvioSimple[]
  ): ProcesaEnvioSimpleFirmanteRequest[] {
    if (!firmantes?.length) {
      return [];
    }

    return firmantes.map(firmante => ({
      Codigo: firmante.codigo,
      Desc: firmante.desc,
      Orden: firmante.orden,
      EsPrincipal: firmante.esPrincipal,
      EsValidador: firmante.esValidador,
      Nombre: firmante.nombre ?? '',
      Apellido1: firmante.apellido1 ?? '',
      Apellido2: firmante.apellido2 ?? '',
      Email: firmante.email ?? '',
      Telefono: firmante.telefono ?? '',
      CodigoEmpleado: firmante.codigoEmpleado ?? null,
      DatosEmpleado: firmante.datosEmpleado
        ? this.mapDatosEmpleadoProcesaEnvioSimpleSalida(firmante.datosEmpleado, firmante)
        : null
    }));
  }

  private mapDatosEmpleadoProcesaEnvioSimpleSalida(
    empleado: Partial<EmpleadoCrud>,
    firmante: FirmanteEnvioSimple
  ) {
    return {
      CodigoEmpleado: empleado.codigo ?? firmante.codigoEmpleado ?? '',
      Nombre: empleado.nombre ?? firmante.nombre ?? '',
      Apellido1: empleado.apellido1 ?? firmante.apellido1 ?? '',
      Apellido2: empleado.apellido2 ?? firmante.apellido2 ?? '',
      EmailPersonal: empleado.mailPersonal ?? firmante.email ?? '',
      EmailProfesional: empleado.mailProfesional ?? '',
      TelefonoPersonal: empleado.telefonoPersonal ?? firmante.telefono ?? '',
      TelefonoProfesional: empleado.telefonoProfesional ?? '',
      Nif: empleado.nif ?? '',
      CodigoEmpresa: empleado.codigoEmpresa ?? '',
      CodigoCentro: empleado.codigoCentro ?? '',
      NombreEmpresa: empleado.nombreEmpresa ?? '',
      NombreCentro: empleado.nombreCentro ?? '',
      EmpresaCif: empleado.empresaCif ?? ''
    };
  }
}
